import Env from '~/env';

export const AppOriginType = {
  TOTEM: 'totem',
  APP: 'app',
  SITE: 'site',
  CREDIT: 'crediario',
} as const;

export type AppOriginType = (typeof AppOriginType)[keyof typeof AppOriginType];

export class MarisaAppUtils {
  static origin: AppOriginType;
  static disableConsortium?: boolean;
  static disableInsurance?: boolean;
  static goToLogin: () => void;
  static goToMbank: () => void;
  static disableMbank: boolean;
  static goToStoresList: () => void;
  static goToConsortium: () => void;
  static openUrl: (url: string) => void;
  static copyToClipboard?: (value: string) => Promise<void | boolean>;
  static shareItem?: (item: string) => Promise<void | boolean>;
  //CREDSYSTEM
  static deviceId: string;
  static OSId: string;
  static OSVersion: string;
  static deviceModel: string;
  ///////////////////////////////////////

  static isTotem = () => this.origin === AppOriginType.TOTEM;

  static getOriginTypeInfos = () => {
    const originInfos = {
      [AppOriginType.APP]: ['APP', 1],
      [AppOriginType.TOTEM]: ['TOTEM', 8],
      [AppOriginType.SITE]: ['SITE', 15],
      [AppOriginType.CREDIT]: ['PORTAL_CRD', 10],
    };

    return originInfos[this.origin];
  };

  static getOriginInsuranceApi = () => {
    let originInfos: any = [];
    if (Env.ENV_NAME === 'hml') {
      originInfos = {
        [AppOriginType.APP]: ['LJMARISAAPIHML', 'l0j4r1S4#w!@hml'],
        [AppOriginType.TOTEM]: ['LJMARISATOTEMHML', 'klj43%@g2Pi'],
        [AppOriginType.SITE]: ['LJMARISASITEMARHML', 'hg3@4^&Dfj'],
        [AppOriginType.CREDIT]: ['LJMARISAPORTCREDHML', 'skpQsjb#@26F2'],
      };
    } else {
      originInfos = {
        [AppOriginType.APP]: ['LJMARISAAPIPRD', 'jh25%$@ghsWF12T'],
        [AppOriginType.TOTEM]: ['LJMARISATOTEMPRD', 'dgcgG@CH@2fg2'],
        [AppOriginType.SITE]: ['LJMARISASITEMARPRD', 'K04JH2djs34$%@h'],
        [AppOriginType.CREDIT]: ['LJMARISAPORTCREDPRD', 'Jj2h@#J@*#'],
      };
    }

    return originInfos[this.origin];
  };
}
